<div mat-dialog-title class="title">
    <mat-icon>edit</mat-icon>&nbsp;{{ data.dialogTitle }}
</div>
<mat-dialog-content>
    <div class="line">
        <mat-form-field>
            <mat-label>{{ 'Text' | translate }}</mat-label>
            <textarea matInput
                      [formControl]="form"
                      cdkTextareaAutosize
                      cdkAutosizeMinRows="2"
                      cdkAutosizeMaxRows="20">
            </textarea>
            <mat-hint align="end">{{ form.value.length }} / {{ MESSAGE_MAX_LENGTH }}</mat-hint>
            <mat-error *ngIf="form.errors && form.errors['required']">{{ 'Field_required' | translate }}</mat-error>
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'Cancel' | translate }}</button>
    <button mat-raised-button (click)="onConfirmClicked()" color="accent">{{ 'Confirm' | translate }}</button>
</mat-dialog-actions>
